import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column';
import colors from 'theme/colors';
import fonts from 'theme/fonts';

export default function VerticalProductCard({
    data,
    onDropdownAction,
    dropDownVisible,
    onMoreClick,
    onProductClick = () => false,
    visibleMoreAction = false,
    isVisiblePrice = false
}) {
    const [price, setPrice] = useState(null);
    const [toggleDropdown, setToggleDropdown] = useState(null);
    const [status, setStatus] = useState(false);

    function renderActions() {
        setToggleDropdown(!toggleDropdown);
        onMoreClick();
    }

    useEffect(() => {
        if (data) {
            data?.batches?.forEach((el) => {
                if (el?.quantity_available > 0 && el?.is_active == 1) {
                    setStatus('disponível');
                }
                if (el?.quantity_available == 0) {
                    setStatus('esgotado');
                }
            });
            setPrice(parseFloat(data?.price));
        }
    }, [data]);

    return (
        <Card status={status} onClick={(e) => onProductClick(e)}>
            <ImageWrapper>
                <StyledImage
                    src={data?.image || '../../assets/images/placeholder-products.png'}
                    alt={data?.name}
                />
                <ImageOverlay />

                {status && (
                    <StatusBadge status={status}>
                        {status}
                    </StatusBadge>
                )}
            </ImageWrapper>

            <ContentInfo>
                <ProductName>{data.name}</ProductName>

                <PriceRow>
                    <PriceCurrency>R$</PriceCurrency>
                    <PriceValue>{parseFloat(data?.price)}</PriceValue>
                </PriceRow>
            </ContentInfo>

            {data.popular && (
                <PopularBadge>Mais vendido</PopularBadge>
            )}
        </Card>
    );
}

const Card = styled(Column)`
    position: relative;
    cursor: pointer;
    transition: transform 0.25s ease, box-shadow 0.25s ease;
    background: ${colors.neutralLight};
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 2px 8px rgba(0, 0, 0, 0.04);

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.05);
    }

    &:hover img {
        transform: scale(1.08);
    }

    &:hover > div:first-child > div:last-of-type {
        opacity: 1;
    }

    ${({ status }) => status === 'esgotado' && `
        opacity: 0.55;

        &:hover {
            transform: none;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 2px 8px rgba(0, 0, 0, 0.04);
        }
    `}
`;

const ImageWrapper = styled.div`
    position: relative;
    width: 100%;
    aspect-ratio: 4 / 3;
    overflow: hidden;
    background: ${colors.neutralDark};
`;

const StyledImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.45s ease;
`;

const ImageOverlay = styled.div`
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.12) 0%, transparent 50%);
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
`;

const StatusBadge = styled.span`
    position: absolute;
    top: 8px;
    left: 8px;
    font-size: 9px;
    font-weight: ${fonts.weight.bold};
    text-transform: capitalize;
    padding: 3px 8px;
    border-radius: 6px;
    letter-spacing: 0.3px;
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);

    ${({ status }) => status === 'disponível' && `
        background: rgba(43, 200, 102, 0.18);
        color: ${colors.successDark};
    `}

    ${({ status }) => status === 'esgotado' && `
        background: rgba(231, 80, 90, 0.18);
        color: ${colors.dangerDark};
    `}
`;

const ContentInfo = styled(Column)`
    width: 100%;
    padding: 10px 12px 12px;
    gap: 6px;
`;

const ProductName = styled.p`
    font-size: ${fonts.sizes.default};
    color: ${colors.nightDark};
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.3;
`;

const PriceRow = styled.div`
    display: flex;
    align-items: baseline;
    gap: 2px;
`;

const PriceCurrency = styled.span`
    font-size: ${fonts.sizes.mini};
    font-weight: ${fonts.weight.bold};
    color: ${colors.primary};
`;

const PriceValue = styled.span`
    font-size: ${fonts.sizes.highlight};
    font-weight: ${fonts.weight.bold};
    color: ${colors.primary};
    line-height: 1;
`;

const PopularBadge = styled.div`
    position: absolute;
    right: 8px;
    top: 8px;
    padding: 3px 8px;
    background: linear-gradient(135deg, ${colors.goldLight}, ${colors.gold});
    color: ${colors.neutralLight};
    border-radius: 6px;
    font-size: 9px;
    font-weight: ${fonts.weight.bold};
    letter-spacing: 0.3px;
    box-shadow: 0 2px 8px rgba(178, 137, 70, 0.35);
    text-transform: uppercase;
`;
